import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { mobileAppDevelopmentConfig } from './servicePageConfigs';

const MobileAppDevelopment = () => <ServicePageTemplate {...mobileAppDevelopmentConfig} />;

export default MobileAppDevelopment;
